// extracted by mini-css-extract-plugin
module.exports = {"controls":"attendance-module--controls--3ecGR","waitlist":"attendance-module--waitlist--3Mat8"};